
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import './asesets/main.css'
import './asesets/css/bootstap2.css'
import './asesets/css/caltmine.css'
import './asesets/css/fontAwesom.css'
// import './asesets/css/mixin.scss'
import './asesets/css/customAdmin.css'
import './asesets/css/selectMin.css'
import './asesets/css/responsive.css'
import "react-toastify/dist/ReactToastify.css";
import Header from './common/header/Header';
import Footer from './common/footer/Footer';
import { lazy, Suspense, useEffect, useState } from 'react';
import { bpbsAllServiceList, UserPermissionAeps2, WalletsShow } from './api/login/Login';
import { getToken } from './utils/localStorage';
import { firebaseVapidKey } from './baseUrl';
import PayoutContextProvider from './modules/payoutService/PayoutProvider';
import { CashBackProvider } from './pages/cashbackPayout/CashBackProvider';
import PayoutByLinkContextProvider from './modules/pay-out-by-link-service/PayoutByLinkProvider';
import { messaging } from './firebase';
import Loader from './common/loader/Loader';
import SessionIdleProvider from "./common/session/SessionIdleProvider";
const SessionExpired = lazy(() => import("./pages/sessionExpired/SessionExpired"));
const HomePage = lazy(() => import("./pages/home"));
const ContactUsPage = lazy(() => import("./pages/contactUs"));
// const ServicesPage = lazy(() => import("./pages/services"));
const AboutPage = lazy(() => import("./pages/about"));
const PrivacyPolicyPage = lazy(() => import("./pages/privacyPolicy"));
const TermConditionPage = lazy(() => import("./pages/termCondition"));
const GrievancePolicyPage = lazy(() => import("./pages/grivencePolicy"));
const OnboardingKycPolicy = lazy(() => import("./pages/onboardingKYC"));
const RefundCancilationPage = lazy(() => import("./pages/refundCancilation"));
const DasRightSectionPage = lazy(() =>
  import("./pages/admin/daseBoardRightSection/DasBoardRightSection")
);
const PaytmWalletPage = lazy(() => import("./pages/admin/paytmWallet"));
const DasBoardPage = lazy(() => import("./pages/admin/dasBoard"));
const MobileDthRecharge = lazy(() =>
  import("./components/services/serviceSection/serviceDetails/MobileDthRechage/MobileDthRecharge")
);
const ServiceParent = lazy(() =>
  import("./components/admin/dasBoard/serviceParent/ServiceParent")
);
const MobileRecharge = lazy(() =>
  import("./components/admin/dasBoard/serviceParent/mobileRecharge/MobileRecharge")
);
const DthRecharge = lazy(() =>
  import("./components/admin/dasBoard/serviceParent/dthRecharge/DthRecharge")
);
const PostPaidRecharge = lazy(() =>
  import("./components/admin/dasBoard/serviceParent/postPaidRecharge/PostPaidRecharge")
);
const MoneyTransferPage = lazy(() =>
  import("./pages/admin/moneyTransfer/MoneyTransfer")
);
const AdharPayPage = lazy(() => import("./pages/admin/adharPay/AdharPay"));
const YblDtmPage = lazy(() => import("./pages/admin/yblDtm"));
const CreditCardPaymentPage = lazy(() =>
  import("./pages/admin/creditCardPayment")
);
const ElectricityBill = lazy(() =>
  import("./components/admin/dasBoard/serviceParent/electricityBill/ElectricityBill")
);
const FastTagRecharge = lazy(() =>
  import("./components/admin/fastTagRecharge/FastTagRecharge")
);
const GasBill = lazy(() =>
  import("./components/admin/dasBoard/serviceParent/gasBill/GasBill")
);
const LandLineBills = lazy(() =>
  import("./components/admin/dasBoard/serviceParent/landLineBill/LandLineBill")
);
const AepsPayoutPage = lazy(() => import("./pages/admin/aepsPayout"));
const AddAepsPayout = lazy(() =>
  import("./components/admin/aepsPayout/addAepsPayout/AddAepsPayout")
);
const ComplainListPage = lazy(() => import("./pages/admin/complainList"));
const RechargeHistoryPage = lazy(() =>
  import("./pages/admin/rechargeHistory")
);
const SearchRechargeHistoryPage = lazy(() =>
  import("./pages/admin/searchRechargeHistory")
);
const MoneyTransferReprotPage = lazy(() =>
  import("./pages/admin/moneyTrasferReport")
);
const FastTagPage = lazy(() => import('./pages/admin/fastagReport'));
const DmtReportPage = lazy(() => import('./pages/admin/dmtReport'));
const DtmReportSearchPage = lazy(() => import('./pages/admin/dtmReportSearch'));
const DmtKycReportPage = lazy(() => import('./pages/admin/dmtKycReport'));
const CreditBilPaymentPage = lazy(() => import('./pages/admin/creditBillPayment'));
const AepsReportPage = lazy(() => import('./pages/admin/aepsReport'));
const AepsTezreportPage = lazy(() => import('./pages/admin/aepsTezReport'));
const AdharPayReportPage = lazy(() => import('./pages/admin/adharPayReport'));
const AepsIcicReportPage = lazy(() => import('./pages/admin/aepsICICReport'));
const AepsTransisation = lazy(() => import('./components/admin/dasBoard/serviceParent/aepsTransisation/AepsTransisation'));
const AepsTezAddPaymentPage = lazy(() => import('./pages/admin/aepsTezAddPayment'));
const AepsFinoUserDasBoardPage = lazy(() => import('./pages/admin/aepsFinoUserDasboard'));
const InsurancedekhoReportPage = lazy(() => import('./pages/admin/insurancedekhoReport'));
const BillPaymentReportPage = lazy(() => import('./pages/admin/billPaymentReport'));
const AccountReportPage = lazy(() => import('./pages/admin/accountReport'));
const BlanceTopUpHistoryPage = lazy(() => import('./pages/admin/blanceTopUpHistory'));
const BankListPage = lazy(() => import('./pages/admin/bankList'));
const PaymentWithDrowReportPage = lazy(() => import('./pages/admin/paymentWithDrowReport'));
const CmsBillReportPage = lazy(() => import('./pages/admin/cmsBillReport'));
const PostPaidBillTransPage = lazy(() => import('./pages/admin/postPaidBillTrans'));
const TurboPaymentRequestPage = lazy(() => import('./pages/admin/turboPaymentRequest'));
const PaymentGateWayPage = lazy(() => import('./pages/admin/paymentGateWay'));
const RupayCardReportPage = lazy(() => import('./pages/admin/rupayCardReport'));
const AepsDevicePage = lazy(() => import('./pages/admin/aepsDeviceDrivers'));

// ---------------------------------------------------
const PasswordChagePage = lazy(() => import('./pages/admin/settings/passwordChage'));
const CreatePinPage = lazy(() => import('./pages/admin/settings/createPin/CreatePinPage'));
const OtpSecurityPage = lazy(() => import('./pages/admin/settings/otpSecurity'));
const TdsCertificatePage = lazy(() => import('./pages/admin/tdsCertificate'));
const MerchantLoginAreaPage = lazy(() => import('./pages/merchantLoginArea/Index'));
const SinUpMerchantPage = lazy(() => import('./pages/merchantLoginArea/sinupMerchant'));
const CompeleteRegister = lazy(() => import('./pages/merchantLoginArea/compeleteRegister'));
const Shipping_Address = lazy(() => import('./pages/admin/shipping_Address'));
const FormBillAdd = lazy(() => import('./pages/admin/shipping_Address/FormBillAdd'));
const BillingAddress = lazy(() => import('./pages/admin/billingAddress'));
const ProfilePage = lazy(() => import('./pages/admin/profilePage'));
const BiometricEkycPage = lazy(() => import('./pages/admin/settings/biometricEkyc/BiometricEkycPage'));
const WalletReportPage = lazy(() => import('./pages/admin/walletReport'));
const PayInReport = lazy(() => import('./components/admin/walletReport/PayInReport'));
const PaymentRequestViewPage = lazy(() => import('./pages/admin/payment/paymentRequestView/PaymentRequestView'));
const AddPaymentRequestPage = lazy(() => import('./pages/admin/payment/addPaymentRequest'));
const OnlinePaymentRequestPage = lazy(() =>
  import("./components/admin/payment/addPaymentRequest/OnlinePaymentRequest")
);

const PaymentRequestPage = lazy(() => import('./pages/admin/payment/paymentRequest'));
const PaymentRequestByMemberPage = lazy(() => import('./pages/admin/payment/paymentRequestByMember'));
const DaseboardCheckPage = lazy(() => import('./pages/admin/daseboardCheck'));
const ActivityLogPage = lazy(() => import('./pages/admin/activityLg'));
const DtmReportDetails = lazy(() => import('./components/admin/dtmReportSearch/dtmReportDetails/DtmReportsDetails'));
const DeclearPage = lazy(() => import('./common/declearPage/DeclearPage'));
const AepsWalletsPage = lazy(() => import('./pages/admin/aepsWallets'));
const TransactionReportPage = lazy(() => import('./pages/admin/tranactionReports'));
const AepsWalletsTrasferPage = lazy(() => import('./pages/admin/aepsWalletTransfer'));
const QucickDhanPage = lazy(() => import('./pages/admin/quickDhan'));
const CompanyBankDetailsPage = lazy(() => import('./pages/admin/companyBankdetails'));
const AepsOnBoardingPage = lazy(() => import('./pages/admin/aepsOnboarding'));
const PrivateRoute = lazy(() => import('./pages/privateRoute/PrivateRoute'));
const BlanceEnquiry = lazy(() => import('./components/admin/aepsOnboarding/comleteOnBoarding/blanceEnquiry/BlanceEnquiry'));
const CaseWithdrow = lazy(() => import('./components/admin/aepsOnboarding/comleteOnBoarding/caseWithdrow/CaseWithdrow'));
const MiniStatement = lazy(() => import('./components/admin/aepsOnboarding/comleteOnBoarding/miniStatement/MiniStatement'));
const AadhaarPay = lazy(() => import('./components/admin/aepsOnboarding/comleteOnBoarding/aadhaarPay/AadhaarPay'));
const OpenDisputPage = lazy(() => import('./pages/admin/disput/openDisput'));
const ClossingDisputPage = lazy(() => import('./pages/admin/disput/clossingDisput'));
const AddTicketPage = lazy(() => import('./pages/admin/disput/AddTicket'));
const ListTicketsPage = lazy(() => import('./pages/admin/disput/listTickets'));
const ListTicketUser = lazy(() => import('./components/admin/disput/listTickets/listTicketUser/ListTicketUser'));
const PackageListPage = lazy(() => import('./pages/admin/package/packagelist'));
const TdsCertificate = lazy(() => import('./components/admin/tdsCertificate/TdsCertifiacete'));
const TdsCertificatee = lazy(() => import('./components/admin/tdsCentificate/TdsCertificate'));
const IdCard = lazy(() => import('./components/admin/idCard/IdCard'));
const Certificate = lazy(() => import('./components/admin/cartificate/cartificate'));
const BcAuthorization = lazy(() => import('./components/admin/bcAuthorizse/tCertificate'));
const BoardBand = lazy(() => import('./components/admin/dasBoard/serviceParent/boardBand/BoardBand'));
const WaterBill = lazy(() => import('./components/admin/dasBoard/serviceParent/water/WaterBill'));
const PackageDetails = lazy(() => import('./components/admin/package/packageDetails/PackageDetails'));
const Commission = lazy(() => import('./components/admin/commission/Commission'));
const Balance = lazy(() => import('./components/admin/balance/Balance'));
const Status = lazy(() => import('./components/admin/status/Status'));
const PackageHistory = lazy(() => import('./components/admin/package/packageHistory/PackageHistory'));
const AirtelCmsPage = lazy(() => import('./pages/admin/airtelCms'));
const CashDepositPage = lazy(() => import('./pages/admin/cashDiposit'));
const QuickDhanPage = lazy(() => import('./pages/admin/quickDhann'));
const AirtelCmsReportPage = lazy(() => import('./pages/admin/airtelCmsReport'));
const Loan = lazy(() => import('./components/loan/Loan'));
const Loanform1 = lazy(() => import('./components/loan/Loanform1'));
const Invoice = lazy(() => import('./components/admin/package/packageDetails/Invoice'));
const AepsDipositPurchge = lazy(() => import('./pages/admin/cashDiposit/aepsDipositPurchage/AepsDipositPurchage'));
const PanServicesPage = lazy(() => import('./pages/admin/panService'));
const NewPanCard = lazy(() => import('./components/admin/panService/newPanCard/NewPanCard'));
const CorectionPanCard = lazy(() => import('./components/admin/panService/corectionPanCard/CorectionPanCard'));
const BusPage = lazy(() => import('./pages/admin/Bus/Index'));
const Userlist = lazy(() => import('./pages/admin/userlist/Userlist'));
const UserReport = lazy(() => import('./pages/admin/userlist/Userreport'));
const Mainwalltreportzsm = lazy(() => import('./pages/admin/userlist/Mainwalltreportzsm'));
const Earningreport = lazy(() => import('./pages/admin/userlist/Earningreport'));
const InvoiceBill = lazy(() => import('./pages/admin/userlist/Invoice'));
const ServiceOperatorList = lazy(() => import('./components/admin/package/packageDetails/Bbpslist'));

// import ServiceSlider from './pages/admin/userlist/ServiceSlider';
const ServiceSlidernew = lazy(() => import('./pages/admin/userlist/ServiceSlider'));
const BPBSService = lazy(() => import('./pages/admin/userlist/BPBSService'));
const LedgerReport = lazy(() => import('./pages/admin/userlist/LedgerReport'));
const BusinessReport = lazy(() => import('./pages/admin/userlist/BusinessReport'));
const AepsInvoice = lazy(() => import('./pages/admin/userlist/AepsInvoice'));
const PayoutInvoice = lazy(() => import('./pages/admin/userlist/Payoutinvoice'));
const CmsInvoice = lazy(() => import('./pages/admin/userlist/CmdInvoice'));
const BillPayment = lazy(() => import('./components/admin/dasBoard/serviceParent/electricityBill/BillPayment'));
const Aadharpayinvoice = lazy(() => import('./pages/admin/userlist/Aadharpayinvoice'));
const NotFound = lazy(() => import('./pages/admin/userlist/NotFound'));
const DeviceInfo = lazy(() => import('./components/admin/dasBoard/serviceParent/water/waterList/DeviceInfo'));
const UtilityReport = lazy(() => import('./pages/admin/userlist/UtilityReport'));
const Userlistzsm = lazy(() => import('./pages/admin/userlist/Userlistzsm'));
const Userlistnew = lazy(() => import('./pages/admin/userlist/Userlistnew'));
const AddPaymentRequest2 = lazy(() => import('./components/admin/payment/addPaymentRequest/AddPaymentRequest2'));
const CouierIndex = lazy(() => import('./pages/couier/CouierIndex'));
const CouierOrder = lazy(() => import('./pages/couier/CouierOrder'));
const OrderDetailsById = lazy(() => import('./pages/couier/OrderDetailsById'));
const NewBankTransfer = lazy(() => import('./pages/NewbankTransfer'));
const BankTransferProvider = lazy(() => import('./pages/NewbankTransfer/BankTransferProvider'));
const PpiIndex = lazy(() => import('./pages/NewbankTransferPPI'));
const AftBankTransfer = lazy(() => import('./pages/AftbankTransfer/AftBankTranfer'));
const BankTransferPPIProvider = lazy(() =>
  import('./pages/NewbankTransferPPI/BankTransferPPIProvider')
);
const PpiTransactionReport = lazy(() =>
  import("./pages/NewbankTransferPPI/PpiTransactionReport")
);
const BBPSServices = lazy(() => import('./pages/bbpsServices'));
const AEPSContextProvider = lazy(() => import('./pages/newaeps/AepsProvider'));
const AEPSPage = lazy(() => import('./pages/newaeps'));
const CourierOrderShip = lazy(() => import('./pages/couier/CourierOrderShip'));
const NonRetailerProtect = lazy(() => import('./pages/privateRoute/NonRetailerPrivate'));
const AsmBankTransferReport = lazy(() => import('./pages/asmzsm-reports/bankTransfer-report'));
const AsmAEPSReport = lazy(() => import('./pages/asmzsm-reports/super-aeps-report'));
const AsmBbpsReport = lazy(() => import('./pages/asmzsm-reports/super-bbps-wallet-report'));
const AsmFundTransferReport = lazy(() => import('./pages/asmzsm-reports/super-fundTransfer-report'));
const PackagePuchaseHistoryforDistributor = lazy(() => import('./components/admin/package/packageHistory/PackagePurchaseHistoryforDistributor'));
const PackageAssignList = lazy(() => import('./components/admin/package/packageAssign/PackageAssignList'));
const ResellerUser = lazy(() => import('./modules/payWallet/User/ResellerUser'));
const PayInWalletReport = lazy(() => import('./modules/payWallet/PayInWalletReport/PayInWalletReport'));
const PayOutWalletReport = lazy(() => import('./modules/payWallet/PayOutWalletReport/PayOutWalletReport'));
const PayoutReport = lazy(() => import("./modules/payWallet/PayOutWalletReport/PayoutReport"));
const ResellerPackageAction = lazy(() => import('./modules/resellerPackage'));
const ResellerPackageUpdate = lazy(() => import('./modules/resellerPackage/resellerPackageUpdate/ResellerPackageUpdate'));
const CashbackPayout = lazy(() => import('./pages/cashbackPayout'));
const TransferPayInTOPayout = lazy(() => import('./modules/payWallet/TransferPayIntoPayout/TransferPayInTOPayout'));
const TransferpayInintoPayoutReport = lazy(() => import('./modules/payWallet/TransferPayInintoPayoutReport/TransferpayInintoPayoutReport'));
const PayInCommingSoon = lazy(() => import('./pages/pay-in-coming-soon/PayInCommingSoon'));
const AirComingSoon = lazy(() => import('./pages/air-coming-soon/AirComingSoon'));
const HotelComingSoon = lazy(() => import('./pages/hotel-coming-soon/HotelComingSoon'));
const LoanComingSoon = lazy(() => import('./pages/loan-coming-soon/LoanComingSoon'));
const IrctcServices = lazy(() => import('./pages/irctc-services/IrctcServices'));
const B2BBankTransfer = lazy(() => import("./pages/B2b"));
const B2BSendMoneyPage = lazy(() => import("./pages/B2b/B2BSendMoneyPage"));
const UpiTransfer = lazy(() => import("./pages/UpiTransfer"));
const IrctcAgentLogin = lazy(() => import('./pages/irctc-services/IrctcAgentLogin'));
const IrctcReport = lazy(() => import('./pages/irctc-services/IrctcReport'))
const IrctcPaymentPageagent977 = lazy(() => import('./pages/irctc-coming-soon/IrctcPaymentPage'));
const BusComingSoon = lazy(() => import('./pages/bus-coming-soon/BusComingSoon'));
const PayoutService = lazy(() => import('./modules/payoutService'));
const BulkPayout = lazy(() => import('./modules/payoutService/BulkPayout'));
const PayOutByLink = lazy(() => import('./modules/pay-out-by-link-service'));
const PayoutForm = lazy(() => import('./modules/pay-out-by-link-service/PayoutForm'));
const PrivacyPolicy = lazy(() => import('./common/privacyPolicy/PrvacyPolicy'));
// const Landing = lazy(() => import('./common/landing'))

const Landing = lazy(() => import('./common/landingSection/pages/Landing'))
const PublicLayout = lazy(() => import('./common/landingSection/layout/PublicLayout'))
const AboutUs = lazy(() => import('./common/landingSection/pages/AboutUs'))
const ContactUs = lazy(() => import('./common/landingSection/pages/ContactUs'))
const Disclaimer = lazy(() => import('./common/landingSection/pages/Disclaimer'))
const ServicesPage = lazy(() => import('./common/landingSection/pages/Services'))
const AepsPage = lazy(() => import("./pages/serviceInfo/aeps"));
const InsurancePage = lazy(() => import("./pages/serviceInfo/insurance"));
const MoneyTransfer = lazy(() => import("./pages/serviceInfo/moneyTransfer"));
const RechargePage = lazy(() => import("./pages/serviceInfo/recharge"));
const BillPaymentsPage = lazy(() => import("./pages/serviceInfo/billPayments"));


function App() {
  const [isLogin, setislogin] = useState(window.localStorage.getItem('login'))
  const location = useLocation()
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);
  const [walletData, setWalletData] = useState()
  const [profiledata, setProfileData] = useState("")
  const navigate = useNavigate();

  const [services, setServices] = useState([]);
  const [isInstantpaypresnt, setIsInstantpayPresent] = useState(true)
  // useEffect(() => {
  //   window.localStorage.setItem('login', false)
  // }, [])

  useEffect(() => {
    const storedRole = localStorage.getItem("userType");
    const pageName = location.pathname.split("/")[1] || "Home";

    if (storedRole) {
      document.title = `BankMudraa || ${storedRole} - ${pageName}`;
    } else {
      document.title = `BankMudraa || ${pageName}`;
    }
  }, [location]);



  const [position, setPosition] = useState({ latitude: null, longitude: null });
  const [tokenNoti, setokenNoti] = useState()
  async function requestPermission() {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const msg = await messaging();
      if (msg) {
        const token = await getToken(msg, {
          vapidKey: firebaseVapidKey
        });
        setokenNoti(token);
      } else {
        alert("Messaging is not supported in this browser");
      }
    } else if (permission === "denied") {
      alert("You denied the notification permission");
    }
  }


  useEffect(() => {
    requestPermission();
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        setPosition({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      });
    } else {
      alert('Geolocation is not available in your browser.')
    }
  }, []);


  const [addPayout, setaddPayout] = useState(false)
  const [addPayoutactiveMessage, setaddPayoutactiveMessage] = useState()
  const [addPayoutbuyMessage, setaddPayoutbuyMessage] = useState()

  const addPayoutPermission = async () => {
    const idMobile = '206'
    try {
      const res = await UserPermissionAeps2(idMobile)
      // console.log(res);
      if (res?.data?.data?.is_active == false) {
        setaddPayoutactiveMessage('Please Admin Side Active User')
      }
      if (res?.data?.data?.is_active == true) {
        if (res?.data?.data?.is_buy == false) {
          setaddPayoutbuyMessage('Please Purchase')
        }
      }
      if (res?.data?.data?.is_active == true && res?.data?.data?.is_buy == true) {
        setaddPayout(true)
      }
    } catch (error) {

    }
  }
  const walletShowHeader = async () => {
    try {
      const res = await WalletsShow()
      setWalletData(res?.data?.data);
    } catch (error) {

    }
  }
  // useEffect(() => {
  //   addPayoutPermission()
  //   walletShowHeader()
  // }, [])
  // Added by Aman singh for auto refresh on dashboard
  useEffect(() => {
    addPayoutPermission()
    walletShowHeader()

    const interval = setInterval(() => {
      walletShowHeader();
    }, 30000);

    return () => clearInterval(interval);
  }, [])
  useEffect(() => {
    const token = window.localStorage.getItem("userToken");
    if (!token) return;
    const fetchServices = async () => {
      try {
        const response = await bpbsAllServiceList();
        // console.log(response, "service22")
        if (!response.error) {
          setServices(response.data);
        }
        else {
          setServices([])
        }
      } catch (error) {
        console.error('Error fetching services:', error);
      }
    };
    fetchServices();
  }, []);
  const withSuspense = (Component) => {
    return (
      <Suspense fallback={<div><Loader /></div>}>
        {Component}
      </Suspense>
    );
  };
  return (
    <SessionIdleProvider>
      <Routes>
        <Route path='login-area' element={withSuspense(<MerchantLoginAreaPage />)} />
        <Route path='/privacy-policy' element={withSuspense(<PrivacyPolicy />)} />
        <Route path='/refund-policy' element={withSuspense(<RefundCancilationPage />)} />
        <Route path='Signup' element={withSuspense(<SinUpMerchantPage position={position} />)} />
        {/* <Route path="/" element={window.localStorage.getItem("userToken") ? <Navigate to="/Dashboard" replace /> : <Navigate to="/login-area" replace />} /> */}
        {/* <Route path="/" element={<Landing />} /> */}

        <Route element={<PublicLayout />}>
          <Route path="/" element={withSuspense(<Landing />)} />
          <Route path="/about-us" element={withSuspense(<AboutUs />)} />
          <Route path="/contact-us" element={withSuspense(<ContactUs />)} />
          <Route path="/disclaimer" element={withSuspense(<Disclaimer />)} />
          <Route path="/services" element={withSuspense(<ServicesPage />)} />
          <Route path="/grievance" element={withSuspense(<GrievancePolicyPage />)} />
          <Route path="/onboarding-kycpolicy" element={withSuspense(<OnboardingKycPolicy />)} />

          <Route path="/aeps" element={withSuspense(<AepsPage />)} />
          <Route path="/insurance" element={withSuspense(<InsurancePage />)} />
          <Route path="/money-transfer" element={withSuspense(<MoneyTransfer />)} />
          <Route path="/recharges" element={withSuspense(<RechargePage />)} />
          <Route path="/bill-payments" element={withSuspense(<BillPaymentsPage />)} />
        </Route>



        <Route path="/session-expired" element={withSuspense(<SessionExpired />)} />
        <Route path='/terms-condition' element={withSuspense(<TermConditionPage />)} />
        {/* <Route path='/contact' element={withSuspense(<ContactUsPage />)} /> */}
        <Route path='/registrationComplete' element={withSuspense(<CompeleteRegister />)} />
        <Route path='/is_self_declare' element={withSuspense(<DeclearPage />)} />
        <Route path='/payout-link-user/:id' element={withSuspense(<PayoutForm />)} />
        <Route path='/' element={<PrivateRoute tokenNoti={tokenNoti} walletData={walletData} services={services} setProfileData={setProfileData} isInstantpaypresnt={isInstantpaypresnt} />}>
          <Route path='/Dashboard' element={withSuspense(<DaseboardCheckPage profiledata={profiledata} walletData={walletData} services={services} position={position} isInstantpaypresnt={isInstantpaypresnt} />)} />
          <Route path='aadhar-pay' element={withSuspense(<AdharPayPage />)} />
          <Route path='aeps-payout-details' element={withSuspense(<AepsPayoutPage />)} />
          <Route path='add-aeps-payout-account' element={withSuspense(addPayout ? <AddAepsPayout /> : <AepsDipositPurchge activeMessage={addPayoutactiveMessage} buyMessage={addPayoutbuyMessage} head={"ADD BANK"} />)} />
          <Route path='recharge_history' element={withSuspense(<RechargeHistoryPage />)} />
          <Route path='search_recharge_history' element={withSuspense(<SearchRechargeHistoryPage />)} />
          <Route path='money_transfer_Reprot' element={withSuspense(<MoneyTransferReprotPage />)} />
          <Route path='wallet-report' element={withSuspense(<WalletReportPage />)} />
          <Route path='payin-report' element={withSuspense(<PayInReport />)} />
          <Route path='dmt_report_search' element={withSuspense(<DtmReportSearchPage walletShowHeader={walletShowHeader} />)} />
          <Route path='details/:id' element={withSuspense(<DtmReportDetails />)} />
          <Route path='dmtkyc_report' element={withSuspense(<DmtKycReportPage />)} />
          <Route path='Aeps_report' element={withSuspense(<AepsReportPage />)} />
          {/* <Route path='aadhaarpay_pay_report' element={<AdharPayReportPage />} /> */}
          <Route path='payment-request-to-company' element={withSuspense(<PaymentRequestViewPage />)} />
          <Route path='add-payment-request' element={withSuspense(<AddPaymentRequestPage />)} />

          <Route path="/online-payment-request" element={withSuspense(<OnlinePaymentRequestPage />)} />
          <Route path='addpaymentrequest' element={withSuspense(<AddPaymentRequest2 />)} />
          <Route path='payment-request-to-distributor' element={withSuspense(<PaymentRequestPage />)} />
          <Route path='payment-request-to-distributor/super-distributor-history' element={withSuspense(<PaymentRequestByMemberPage />)} />
          <Route path='change_password' element={withSuspense(<PasswordChagePage />)} />
          <Route path='shipping_Address' element={withSuspense(<Shipping_Address />)} />
          <Route path='billing_Address' element={withSuspense(<BillingAddress />)} />
          <Route path='shipping_AddressaForm' element={withSuspense(<FormBillAdd ship={'Shipping'} type='Shipping' />)} />
          <Route path='/admin/shipping_AddressaForm/:id' element={withSuspense(<FormBillAdd ship={'Shipping'} type='Shipping' />)} />
          <Route path='billing_AddressaForm' element={withSuspense(<FormBillAdd ship={'billing'} type='Billing' />)} />
          <Route path='/admin/billing_AddressaForm/:id' element={withSuspense(<FormBillAdd ship={'billing'} type='Billing' />)} />
          <Route path='change_txnpassword' element={withSuspense(<CreatePinPage />)} />
          <Route path='profile' element={withSuspense(<ProfilePage />)} />
          <Route path='biometric_ekyc' element={withSuspense(<BiometricEkycPage />)} />

          <Route path='aeps-wallet' element={withSuspense(<AepsWalletsPage />)} />
          <Route path='aeps-transaction-report' element={withSuspense(<TransactionReportPage />)} />
          <Route path='aeps-wallet-transfer' element={withSuspense(<AepsWalletsTrasferPage />)} />

          <Route path='company-bank-details' element={withSuspense(<CompanyBankDetailsPage />)} />
          <Route path='open-dispute' element={withSuspense(<OpenDisputPage />)} />
          <Route path='clossing-Dispute' element={withSuspense(<ClossingDisputPage />)} />
          <Route path='add-ticket/:id' element={withSuspense(<AddTicketPage />)} />
          <Route path='add-ticket' element={withSuspense(<AddTicketPage />)} />
          <Route path='list-tickets' element={withSuspense(<ListTicketsPage />)} />
          <Route path='list-ticket-user/:id' element={withSuspense(<ListTicketUser />)} />
          <Route path='package-list' element={withSuspense(<PackageListPage />)} />
          <Route path='package-details/:id' element={withSuspense(<PackageDetails walletShowHeader={walletShowHeader} walletData2={walletData} />)} />
          <Route path='package-history' element={withSuspense(<PackageHistory />)} />
          <Route path='package-purchase-history' element={withSuspense(<PackagePuchaseHistoryforDistributor />)} />
          <Route path='package-assign' element={withSuspense(<PackageAssignList />)} />

          <Route path='certificate' element={withSuspense(<Certificate />)} />
          {/* <Route path='bc-authorization' element={<BcAuthorization />} /> */}


          <Route path='airtel-cms' element={withSuspense(<AirtelCmsPage walletShowHeader={walletShowHeader} />)} />

          <Route path='airtel-cms-report' element={withSuspense(<AirtelCmsReportPage />)} />
          <Route path='pan-service' element={withSuspense(<PanServicesPage />)} />
          <Route path='new-pan' element={withSuspense(<NewPanCard />)} />
          <Route path='corection-pan-card' element={withSuspense(<CorectionPanCard />)} />

          <Route path='invoice' element={withSuspense(<Invoice />)} />
          {/* <Route path="network" element={<Userlist walletShowHeader={walletShowHeader}/>} /> */}
          <Route path="network" element={withSuspense(<Userlistnew walletShowHeader={walletShowHeader} position={position} />)} />
          <Route path="networkzsmasm" element={withSuspense(<Userlistzsm walletShowHeader={walletShowHeader} position={position} />)} />
          <Route path="/user-report/:userId" element={withSuspense(<UserReport />)} />
          <Route path="/main-report/:userId" element={withSuspense(<Mainwalltreportzsm />)} />
          <Route path="earning-report" element={withSuspense(<Earningreport />)} />
          <Route path="/bill-invoice/:id" element={withSuspense(<InvoiceBill />)} />
          <Route path="/payout-invoice/:id" element={withSuspense(<PayoutInvoice />)} />
          <Route path="/cms-invoice/:id" element={withSuspense(<CmsInvoice />)} />
          {/* <Route path="/bbslistoperator" element={<ServiceOperatorList />} /> */}


          <Route
            path="/ledger-report"
            element={withSuspense(<LedgerReport />)}
          />
          <Route
            path="/service-report"
            element={withSuspense(<BusinessReport />)}
          />


          {/* //AEPS Invoice */}
          <Route
            path="/aeps-invoice/:id"
            element={withSuspense(<AepsInvoice />)}
          />
          <Route
            path="/aadharpay-invoice/:id"
            element={withSuspense(<Aadharpayinvoice />)}

          />


          <Route path="/utility-report" element={withSuspense(<UtilityReport />)} />
          <Route path="/pay-in-service" element={withSuspense(<PayInCommingSoon />)} />
          <Route path="/air-booking-service" element={withSuspense(<AirComingSoon />)} />
          <Route path="/Hotel-booking-service" element={withSuspense(<HotelComingSoon />)} />
          <Route path="/loan-services/:loanType" element={withSuspense(<LoanComingSoon />)} />
          <Route path="/loan-service" element={withSuspense(<LoanComingSoon />)} />
          <Route path="/home-loan-service" element={withSuspense(<LoanComingSoon defaultType="home-loan" />)} />
          <Route path="/personal-loan-service" element={withSuspense(<LoanComingSoon defaultType="personal-loan" />)} />
          <Route path="/instasalary-loan-service" element={withSuspense(<LoanComingSoon defaultType="instasalary" />)} />
          <Route path="/loan-against-property-service" element={withSuspense(<LoanComingSoon defaultType="loan-against-property" />)} />
          <Route path="/auto-loan-service" element={withSuspense(<LoanComingSoon defaultType="auto-loan" />)} />
          <Route path="/education-loan-service" element={withSuspense(<LoanComingSoon defaultType="education-loan" />)} />
          <Route path="/Irctc-booking-service" element={withSuspense(<IrctcServices />)} />
          <Route path="/agent-login" element={withSuspense(<IrctcAgentLogin />)} />
          <Route path="/Irctc-Report" element={withSuspense(<IrctcReport />)} />
          <Route path="/irctc/agent977/paymentpage" element={withSuspense(<IrctcPaymentPageagent977 />)} />
          <Route path="/Bus-booking-service" element={withSuspense(<BusComingSoon />)} />
          <Route path="/B2B-bankTransfer" element={withSuspense(<B2BBankTransfer />)} />
          <Route path="/B2B-send-money" element={withSuspense(<B2BSendMoneyPage />)} />
          <Route path="/payout-report" element={withSuspense(<PayoutReport />)} />
          <Route path="/UPI-Transfer" element={withSuspense(<UpiTransfer />)} />
          <Route path="/pay-out-service" key={location.key} element={
            withSuspense(<PayoutContextProvider>
              <PayoutService />
            </PayoutContextProvider>)
          } />
          <Route path="/bulk-pay-out-service" key={location.key} element={withSuspense(<BulkPayout />)} />

          <Route path="/courier-onboard" element={withSuspense(<CouierIndex walletShowHeader={walletShowHeader} key={location.key} />)} />

          <Route path="/order-details" element={withSuspense(<CouierOrder key={location.key} />)} />

          <Route path="/order-ship" element={withSuspense(<CourierOrderShip key={location.key} />)} />

          <Route path="/order-details/:orderId/:trackingId?" element={withSuspense(<OrderDetailsById />)} />

          <Route path="/services/:serviceId" element={withSuspense(<BBPSServices key={location.key} walletCall={walletShowHeader} />)} />

          <Route
            path="/bank-transfer"
            element={withSuspense(
              <BankTransferProvider key={location.key} walletCall={walletShowHeader}>
                <NewBankTransfer />
              </BankTransferProvider>
            )}
          />
          <Route
            path="/bank-ppi"
            element={withSuspense(
              <BankTransferPPIProvider>
                <PpiIndex />
              </BankTransferPPIProvider>
            )}
          />

          <Route
            path="aft-bank-transfer"
            element={withSuspense(<AftBankTransfer />)}
          />
          <Route
            path="/ppi-transaction-report"
            element={withSuspense(<PpiTransactionReport />)}
          />


          <Route
            path="/aeps-services/"
            element={withSuspense(
              <AEPSContextProvider key={location.key} walletCall={walletShowHeader}>
                <AEPSPage />
              </AEPSContextProvider>
            )}
          />

          <Route
            path="/aeps-services/:service"
            element={withSuspense(
              <AEPSContextProvider walletCall={walletShowHeader} key={location.key}>
                <AEPSPage />
              </AEPSContextProvider>
            )}
          />

          <Route
            path="/cashback-settlement"
            element={withSuspense(
              <CashBackProvider walletCall={walletShowHeader} walletData={walletData} key={location.key}>
                <CashbackPayout />
              </CashBackProvider>
            )}
          />

          <Route
            path="/pay-out-by-link-service"
            element={withSuspense(
              <PayoutByLinkContextProvider walletCall={walletShowHeader} walletData={walletData} key={location.key}>
                <PayOutByLink />
              </PayoutByLinkContextProvider>
            )}
          />

          {/* asm report route start here */}
          <Route path="/super" element={withSuspense(<NonRetailerProtect />)}>
            <Route
              path="bank-transfer-report"
              element={withSuspense(<AsmBankTransferReport key={location.key} title="Bank Transfer Report" />)}
            />
            <Route
              path="aeps-transfer-report"
              element={withSuspense(<AsmAEPSReport key={location.key} title="AEPS Transfer Report" />)}
            />
            <Route
              path="bbps-report"
              element={withSuspense(<AsmBbpsReport key={location.key} title="BBPS Report" />)}
            />
            <Route
              path="fund-transfer-report"
              element={withSuspense(<AsmFundTransferReport key={location.key} title="Fund Transfer Report" />)}
            />
          </Route>


          <Route path="/reseller-user" element={withSuspense(<ResellerUser />)} />
          <Route path="/payin-wallet-to-payout-wallet" element={withSuspense(<TransferPayInTOPayout walletCall={walletShowHeader} walletData={walletData} />)} />
          <Route path="/payin-wallet-to-payout-wallet-report" element={withSuspense(<TransferpayInintoPayoutReport />)} />
          <Route path="/reseller-user-package-list/:id" element={withSuspense(<ResellerPackageAction />)} />
          <Route path="/reseller-package-commission-update/:id" element={withSuspense(<ResellerPackageUpdate />)} />
          <Route path="/pay-in-wallet-report/:id?" element={withSuspense(<PayInWalletReport />)} />
          <Route path="/pay-out-report" element={withSuspense(<PayOutWalletReport />)} />
        </Route>
        {/* <Route /> */}
      </Routes>
    </SessionIdleProvider>
  );
}

export default App;
